var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [_c("Title", { attrs: { title: _vm.headerText() } })],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "body" },
        [
          _vm.ticketCreated
            ? _c("Success")
            : _vm.ticketCreationError
              ? _c("Error")
              : _vm.step === 0
                ? _c("CancellationType")
                : _vm.step === 1
                  ? _c("CancellationData")
                  : _vm.shouldRequestRefundInfo
                    ? _c("CancellationRefund")
                    : _vm.shouldRequestRescheduleInfo
                      ? _c("CancellationReschedule")
                      : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          !_vm.cancellationAction
            ? _c("Tip", [
                _vm._v(
                  "\n      Selecione uma das opções acima ou clique no botão abaixo para voltar\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.step === 0 && _vm.ticketCreated) || _vm.step > 0
            ? _c(
                "button",
                {
                  staticClass: "btn bg-purple",
                  class: {
                    "btn-disabled": !_vm.ticketCreated && !_vm.allowToSendTicket
                  },
                  on: { click: _vm.nextStep }
                },
                [
                  _c("span", [
                    _vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.ticketCreated && !_vm.ticketCreationError
            ? _c(
                "button",
                {
                  staticClass: "btn bg-outlined",
                  on: { click: _vm.previousStep }
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.step != 0 ? "voltar" : "não quero cancelar"
                        ) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-067044a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067044a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Cancellation/Index.vue
// module id = null
// module chunks = 